module.exports = __webpack_public_path__ + "static/media/agency.432ba528.jpg";